import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';

export const itemHoverStyles = `
  --item-hover-color: ${token('color.background.neutral.subtle.pressed', colors.N30)};
`;

export const itemSelectedStyles = ` 
  --item-selected-color: ${token('color.background.selected', colors.B50)};
`;
